import { render, staticRenderFns } from "./CrMenu.vue?vue&type=template&id=52916f04&scoped=true"
import script from "./CrMenu.vue?vue&type=script&lang=js"
export * from "./CrMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52916f04",
  null
  
)

export default component.exports